export class GlobalListeners {
  constructor() {
    this.selectors = {
      quickAdds: '[quick-add-qf]',
      productForm: 'form[action="/cart/add"]',
      openSideCart: '.openSideCart',
      closeSideCart: '.closeSideCart',
      closeSelected: '.cart-drawer--close',
      removeButtons: '.cart .items-wrapper .side-cart-item .remove-item',
      quantitySelectorPlus: '.cart .items-wrapper .side-cart-item .quantity-wrapper .plus',
      quantitySelectorMinus: '.cart .items-wrapper .side-cart-item .quantity-wrapper .minus',
      cartCount: '.cart-count',
      accordion: 'accordion',
      product_description: '[read-more-container]',
      recommendationsTrigger: '.recommendations-trigger',
      megaMenuLinks: '.top-level-links-wrapper',
      megaMenuImages: '.mega-menu-dropdown_outer-wrapper img',
      mobileSearch: '[data-open-search]',
      quantitySelect: '[quantity-select]',
      quantityPlus: '[quantity-plus]',
      quantityMinus: '[quantity-minus]',
      quantity: '[quantity]',
      quickAddTrigger: '[quick-add-trigger]',
      quickAddClose: '[close-quick-add-trigger]',
      quickAddPopup: '[quick-add-popup]',
      sizeGuide: '[size-guide]',
      sizeGuideTab: '[size-guide-tab]',
      variantAdd: '[variant-quick-add]',
      savedItem: '[saved-item-add]',
    };

    this.init();
  }

  init() {
    window.log("Initializing global QF listeners");
    document.body.addEventListener('click', this.handleEvent.bind(this));
    document.body.addEventListener('submit', this.handleFormSubmit.bind(this));
    this.cartRelated();
    this.showMegaMenuImages();
    this.sizeGuide();
  }

  handleFormSubmit(e) {
    this.productForm(e);
  }

  handleEvent(e) {
    this.megaMenuBrandsTabs(e);
    this.headerSearch(e);
    this.siteCart(e);
    this.quantityButtons(e);
    this.removeCartItem(e);
    this.accordions(e);
    this.productDescriptions(e);
    this.sideCartTabs(e);
    this.mobileMenu(e);
    this.recommendationsTrigger(e);
    this.quantityPlus(e);
    this.quantityMinus(e);
    this.quickAdd(e);
    this.closeQuickAddPopup(e);
    this.variantAdd(e);
    this.saved_item_add_to_cart(e);
    this.closeSelected(e);
  }

  closeSelected(e) {
    const closeSelected = e.target.closest(this.selectors.closeSelected);
    if (closeSelected) {
      e.preventDefault();
      const recommended = document.querySelector('.side-cart-recommended');
      if (recommended) {
        recommended.classList.remove('open');
      }
    }
  }

  sizeGuide() {
    const sizeGuide = document.querySelector(this.selectors.sizeGuide);
    if (sizeGuide) {
      sizeGuide.addEventListener('click', e => {
        const sizeGuideTab = document.querySelector(this.selectors.sizeGuideTab);
        if (sizeGuideTab) {
          sizeGuideTab.click();
        }
      });
    }
  }

  saved_item_add_to_cart(e) {
    if (e.target.closest(this.selectors.savedItem)) {
      e.preventDefault();
      const saved_item_add = e.target.closest(this.selectors.savedItem);
      const id = saved_item_add.closest('[saved-item]').dataset.variantId;
      const quantity = 1;
      if (id && quantity) {
        window.cart.add({ items: [{ "id": id, "quantity": quantity }] });
        // window.wishlist.buttonCheck();
      }
    }
  }

  recommendationsTrigger(e) {
    if (e.target.closest(this.selectors.recommendationsTrigger)) {
      e.preventDefault();
      const recommendations = document.querySelector('[data-tab="for-you-cart"]');
      if (recommendations) {
        recommendations.click();
      }
    }
  }

  quickAdd(e) {
    const quickAddTrigger = e.target.closest(this.selectors.quickAddTrigger);
    if (quickAddTrigger) {
      e.preventDefault();
      const default_variant = quickAddTrigger.dataset.defaultVariant;
      if (default_variant) {
        const quantity = parseInt(quickAddTrigger.dataset.quantity);
        if (quickAddTrigger.dataset.id && quantity > 0) {
          window.cart.add({ items: [{ "id": quickAddTrigger.dataset.id, "quantity": quantity }] });

          window.wishlist.buttonCheck();

        }
      } else {
        const quickAddPopup = quickAddTrigger.previousElementSibling;
        if (quickAddPopup) {
          quickAddPopup.classList.add("active");
          setTimeout(() => {
            quickAddPopup.classList.add("shadow");
            quickAddPopup.closest(".product-card").classList.add("no-overflow");
          }, 300);
          const section_name = "v3-product-json";
          const product_handle = quickAddTrigger.dataset.productHandle;
          const section_id = quickAddTrigger.dataset.sectionId;
          // Fetch product data
          if (!quickAddPopup.classList.contains("opened")) {
            // Have to fetch the product json using section render because the product.js returns a json object that is different from the product json liquid object
            fetch(window.Shopify.routes.root + `products/${product_handle}?sections=${section_name}`)
              .then(response => response.json())
              .then(data => {
                const product_json = JSON.parse(data[section_name].split("<!-- product-json -->")[1]);
                new window.ProductFormVariantSelect(product_json, section_id, false);
                quickAddPopup.classList.add("opened");
              });
          }
        }
      }
    }
  }

  variantAdd(e) {
    const variantAddTrigger = e.target.closest(this.selectors.variantAdd);
    if (variantAddTrigger) {
      e.preventDefault();
      window.cart.add({ items: [{ "id": variantAddTrigger.dataset.id, "quantity": 1 }] });

      window.wishlist.buttonCheck();

    }
  }

  closeQuickAddPopup(e) {
    const quickAddClose = e.target.closest(this.selectors.quickAddClose);
    if (quickAddClose) {
      e.preventDefault();
      const quickAddPopup = quickAddClose.closest(this.selectors.quickAddPopup);
      if (quickAddPopup) {
        quickAddPopup.closest(".product-card").classList.remove("no-overflow");
        quickAddPopup.classList.remove("active");
        quickAddPopup.classList.remove("shadow");
      }
    }
  }

  productForm(e) {
    const productForm = e.target.closest(this.selectors.productForm);
    if (productForm) {
      e.preventDefault();
      const product_id = productForm.getAttribute("id").split("_").pop();
      const quantity_el = productForm.querySelector("[quantity-select] input[type='number']");
      let quantity = 1;
      if (quantity_el) {
        quantity = parseInt(quantity_el.value);
      }
      const section_id = productForm.getAttribute("data-section-id");
      const id = productForm.querySelector("#product-id-" + section_id + "-" + product_id).value;

      let properties = {};
      const propertyFields = document.querySelectorAll('.property');

      if (propertyFields) {
        propertyFields.forEach(field => {

          const key = field.getAttribute('name');
          const value = field.value;
          if (key && value) {
            properties[key] = value;
          }
        });
      }

      if (quantity && id) {
        window.cart.add({ items: [{ "id": id, "quantity": quantity, "properties": properties }] });
        window.wishlist.buttonCheck();
      }
    }
  }

  quantityPlus(e) {
    const plus = e.target.closest(this.selectors.quantityPlus);

    if (plus) {
      const quantity_input = plus.closest(this.selectors.quantitySelect).querySelector("input[type='number']");
      const quantity = plus.closest(this.selectors.quantitySelect).querySelector(this.selectors.quantity);
      const new_value = parseInt(quantity_input.value) + 1;
      const max = quantity_input.getAttribute("max");

      if (new_value <= max) {
        quantity_input.value = new_value;
        quantity.innerHTML = new_value;
        this.setProductSubtotal(quantity_input)
      }

    }
  }

  quantityMinus(e) {
    const minus = e.target.closest(this.selectors.quantityMinus);

    if (minus) {
      const quantity_input = minus.closest(this.selectors.quantitySelect).querySelector("input[type='number']");
      const quantity = minus.closest(this.selectors.quantitySelect).querySelector(this.selectors.quantity);
      const new_value = parseInt(quantity_input.value) - 1;

      if (new_value > 0) {
        quantity_input.value = new_value;
        quantity.innerHTML = new_value;
        this.setProductSubtotal(quantity_input)
      }

    }
  }

  setProductSubtotal(quantity_input) {
    const product_form = quantity_input.closest(this.selectors.productForm);
    const subtotal_el = product_form.querySelector('[product-sub-total]');
    const maxtotal_el = product_form.querySelector('[product-max-total]');
    const savingtotal_el = product_form.querySelector('[product-saving-total]');

    if (!subtotal_el) return;

    const price_per = subtotal_el.getAttribute("data-variant-price");
    const max_price_per = maxtotal_el ? maxtotal_el.getAttribute("data-variant-total-price") : null;
    const saving_price_per = savingtotal_el ? savingtotal_el.getAttribute("data-variant-saving-price") : null;

    const subtotal = (parseFloat(price_per) * parseFloat(quantity_input.value));
    const maxtotal = max_price_per ? (parseFloat(max_price_per) * parseFloat(quantity_input.value)) : null;
    const savingtotal = maxtotal && saving_price_per ? maxtotal - subtotal : null;

    const money_format = quantity_input.getAttribute("data-money-format");
    const formattedPrice = Shopify.formatMoney(subtotal, money_format);
    const formattedMaxTotal = maxtotal ? Shopify.formatMoney(maxtotal, money_format) : null;
    const formattedSavingTotal = savingtotal ? Shopify.formatMoney(savingtotal, money_format) : null;

    subtotal_el.innerHTML = formattedPrice;
    if (maxtotal_el) maxtotal_el.innerHTML = formattedMaxTotal;
    if (savingtotal_el) savingtotal_el.innerHTML = formattedSavingTotal;
  }

  siteCart(e) {
    // SITE CART OPEN AND CLOSE
    if (!window.QF.settings.sideCart) return;

    const openSideCart = e.target.closest(this.selectors.openSideCart);
    if (openSideCart) {
      e.preventDefault();
      window.cart.openSideCart();
      window.wishlist.buttonCheck();
    }

    const closeSideCart = e.target.closest(this.selectors.closeSideCart);
    if (closeSideCart) {
      e.preventDefault();
      window.cart.closeSideCart();
    }

    if (e.target.classList.contains('cart-drawer-container')) {
      window.cart.closeSideCart();
    }
  }


  quantityButtons(e) {
    // QUANTITY PLUS CART
    const quantityPlus = e.target.closest(this.selectors.quantitySelectorPlus);
    if (quantityPlus) {
      if (quantityPlus.getAttribute("data-pending") === "true") return;
      quantityPlus.setAttribute("data-pending", true);

      const quantityElement = quantityPlus.parentNode.querySelector(".quantity span");
      const stock = quantityElement.getAttribute("data-stock");
      const current = parseInt(quantityElement.innerHTML);
      const variant_key = quantityElement.closest('.side-cart-item').getAttribute("data-variant-key");
      const inv_policy = quantityElement.getAttribute("data-inventory-policy");
      if (inv_policy === "continue" || stock > 0) {
        // if in stock or continue selling when out of stock, update cart
        const updated = current + 1;
        window.cart.change({ "id": variant_key, "quantity": updated });
        setTimeout(() => {
          window.wishlist.buttonCheck();
        }, 400);
      }
    }

    // QUANTITY MINUS CART
    const quantityMinus = e.target.closest(this.selectors.quantitySelectorMinus);
    if (quantityMinus) {
      if (quantityMinus.getAttribute("data-pending") === "true") return;
      quantityMinus.setAttribute("data-pending", true);

      const quantity = quantityMinus.parentNode.querySelector(".quantity span");
      const current = parseInt(quantity.innerHTML);
      const variant_key = quantity.closest('.side-cart-item').getAttribute("data-variant-key");

      if (current > 0) {
        const updated = current - 1;
        window.cart.change({ "id": variant_key, "quantity": updated });
        setTimeout(() => {
          window.wishlist.buttonCheck();
        }, 400);
      }
    }
  }

  removeCartItem(e) {
    // REMOVE ITEM CART
    const removeButtons = e.target.closest(this.selectors.removeButtons);
    if (removeButtons) {
      const variant_key = removeButtons.closest('.side-cart-item').getAttribute("data-variant-key");
      window.cart.change({ "id": variant_key, "quantity": 0});
    }
  }

  cartRelated() {
    // update side cart/cart after change
    const renderCarts = () => {
      if (window.template === "cart") {
        window.cart.reRenderCart();
      } else {
        if (window.QF.settings.ajax_open_side_cart) {
          window.cart.openSideCart();
        } else if (window.QF.settings.ajax_toast) {
          window.cart.reRenderSideCart();
        }
      }
    };
    window.addEventListener("cart_changed", renderCarts);
    window.addEventListener("item_removed", renderCarts);

    // CART COUNT
    window.addEventListener("cart_changed", e => {
      if (e.detail.cart) {
        const cartCount = document.querySelectorAll(".cart-count");
        cartCount.forEach(count => {
          count.innerHTML = e.detail.cart.item_count;
        });
      }
    });
  }

  headerSearch(e) {
    const search = document.querySelector('.mega-menu .mega-menu-controls .header-search-bar-wrapper');
    const searchTrigger = document.querySelector('.mega-menu .mega-menu-controls [data-open-search]');
    const searchInput = document.querySelector('.mega-menu .mega-menu-controls .header-search-bar-wrapper .search-bar-qf input');

    if (search) {
      const target = e.target;

      if (target === searchTrigger || target.closest('[data-open-search]')) {
        if (!searchTrigger.classList.contains('active')) {
          searchTrigger.classList.add('active');
          search.classList.add('active');
          searchInput.focus();
        }
      } else if (target === searchInput) {
        // Do nothing if the search input is clicked
        return;
      } else {
        searchTrigger.classList.remove('active');
        search.classList.remove('active');
      }

      if (e.key === 'Escape') {
        if (searchTrigger.classList.contains('active')) {
          searchTrigger.classList.remove('active');
          search.classList.remove('active');
        }
      }
    }
  }

  mobileMenu(e) {
    const menu = document.querySelector('.mobile-menu-outer-wrapper');
    const menuTrigger = document.querySelector('.openMenu');
    const mobileTrigger = e.target.closest(this.selectors.mobileSearch);
    const predictiveSearch = document.querySelector('.predictive-search');
    const mobileSearch = document.querySelector('.mobile-menu-search');
    const closeMobileMenu = document.querySelector('.close-mobile-menu');
    const closeTrigger = document.querySelector('.closeMenu');

    if (menuTrigger) {
      if(e.target === menuTrigger || e.target.closest('.openMenu')) {
        if (menuTrigger.classList.contains('active')) {
          menu.classList.remove('active');
          menuTrigger.classList.remove('active');
          predictiveSearch.classList.remove('active');
          closeTrigger.classList.remove('active');
        } else {
          menu.classList.add('active');
          menuTrigger.classList.add('active');
          closeTrigger.classList.add('active');
        }
      }

    }
    if (mobileTrigger) {

        if (mobileTrigger.classList.contains('active')) {
          mobileTrigger.classList.remove('active');
          predictiveSearch.classList.remove('active');
          mobileSearch.classList.remove('active');
        } else {
          mobileTrigger.classList.add('active');
          predictiveSearch.classList.add('active');
          mobileSearch.classList.add('active');
        }

    }
    if (closeMobileMenu || closeTrigger) {
      if(e.target.closest('.closeMenu') || e.target.closest('.close-mobile-menu')) {
        console.log('close menu');
        const mobileTrig = document.querySelector('[data-open-search]');
        mobileTrig.classList.remove('active');
        predictiveSearch.classList.remove('active');
        mobileSearch.classList.remove('active');
        menuTrigger.classList.remove('active');
        closeTrigger.classList.remove('active');
        menu.classList.remove('active');
      }
    }
    menu.addEventListener('click', e => {
      if (e.target.classList.contains('mobile-menu-outer-wrapper')) {
        menu.classList.remove('active');
        menuTrigger.classList.remove('active');
        const mobileTrig = document.querySelector('[data-open-search]');
        mobileTrig.classList.remove('active');
      }
    });
  }

  sideCartTabs(e) {
    if (e.target && e.target.closest) {
      const cartTab = e.target.closest('.cart-tab');

      if (cartTab && !cartTab.classList.contains('active')) {

        const cartTabs = document.querySelectorAll('.cart-tab');

        cartTabs.forEach(tab => {
          tab.classList.remove('active');
        });

        let tabSelected = cartTab;
        tabSelected.classList.add('active');
        let tabData = tabSelected.getAttribute('data-tab');
        let cartContents = document.querySelectorAll('.cart-content');

        cartContents.forEach(cartContent => {
          cartContent.style.display = 'none';
        });

        document.querySelector('.' + tabData).style.display = 'flex';

        if (tabData === 'save-later-cart') {
          if (window.wishlist && window.wishlist.needsUpdate) {
            window.wishlist.initSideCartGrid();
            window.wishlist.needsUpdate = false;
          } else {
            window.wishlist.initSideCartGrid();
          }
        }
        if (tabData === 'saved-cart') {
          if (window.wishlist && window.wishlist.needsUpdate) {
            window.wishlist.initSideCartGridTwo();
            window.wishlist.needsUpdate = false;
          } else {
            window.wishlist.initSideCartGridTwo();
          }
        }
      }
    }
  }

  accordions(e) {
    if (e.target.classList.contains(this.selectors.accordion)) {
      e.preventDefault();

      const accordion = e.target;
      const parent = accordion.parentElement;
      const sibling_accordions = parent.getElementsByClassName(this.selectors.accordion);
      const panel = accordion.nextElementSibling;


      if (sibling_accordions) {
        Array.from(sibling_accordions).forEach((acc) => {
          if (acc != accordion || accordion.classList.contains('active')) {
            acc.nextElementSibling.style.maxHeight = null;
            acc.classList.remove("active");

          } else {
            accordion.classList.add("active");
            panel.style.maxHeight = panel.scrollHeight + "px";
          }
        });
      }

    }
  }

  productDescriptions(e) {
    if (e.target.classList.contains('read-more')) {
      let el = e.target;

      if (el.classList.contains("active")) {
        el.classList.remove("active");
        el.closest(this.selectors.product_description).classList.remove("active");
        if (el.dataset.readMoreText != "") {
          el.innerHTML = el.dataset.readMoreText;
        }
      } else {
        el.classList.add("active");
        el.closest(this.selectors.product_description).classList.add("active");
        if (el.dataset.readLessText != "") {
          el.innerHTML = el.dataset.readLessText;
        }
      }

    }

  }

  showMegaMenuImages() {
    const megaMenuLinks = document.querySelector(this.selectors.megaMenuLinks);
    const megaMenuImages = document.querySelectorAll(this.selectors.megaMenuImages);
    if (megaMenuLinks) {
      const mouseEnterHandler = () => {
        if (megaMenuImages) {
          megaMenuImages.forEach(image => {
            const data_src = image.getAttribute('data-src');
            image.src = data_src;
          });
          megaMenuLinks.removeEventListener('mouseenter', mouseEnterHandler);
        }
      };
      megaMenuLinks.addEventListener('mouseenter', mouseEnterHandler);
    }
  }

  disableScroll() {
    document.body.style.overflow = 'hidden';
}

  enableScroll() {
      document.body.style.overflow = 'auto';
  }

  megaMenuBrandsTabs(e) {
    if (e.target.classList.contains('tab-link-mm-brands')) {
      e.preventDefault();
      const tab = e.target;
      const index = tab.getAttribute('data-mm-tab');
      const tabs = document.querySelectorAll('.tab-link-mm-brands');
      const tabContents = document.querySelectorAll('.tab-content-mm-brands');

      tabs.forEach(tab => {
        tab.classList.remove('active');
      });

      tabContents.forEach(tabContent => {
        tabContent.classList.remove('active');
      });

      tab.classList.add('active');

      document.querySelector(`.tab-content-mm-brands[data-mm-tab="${index}"]`).classList.add('active');

    }
  }

}

// window.GlobalListeners = GlobalListeners;
